<span [ngSwitch]="status">
   <span class="badge-status success-with-border" *ngSwitchCase="offerStatusEnum.Active">
    {{"offers.active" | translate}}
  </span>
   <span class="badge-status danger" *ngSwitchCase="offerStatusEnum.Expired">
    {{"offers.expired" | translate}}
  </span>
   <span class="badge-status red_3" *ngSwitchCase="offerStatusEnum.Blocked">
    {{"offers.blocked" | translate}}
  </span>
   <span class="badge-status purple" *ngSwitchCase="offerStatusEnum.ComingSoon">
    {{"offers.comingSoon" | translate}}
  </span>
</span>
